import React from 'react';

const Icon119OrientationSingleArmSofaRight = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <path
      d="M176.78,317.75h187.85c7.98,0,14.45,6.47,14.45,14.45v202.3h-216.75v-202.3c0-7.98,6.47-14.45,14.45-14.45Z"
      transform="translate(541.4 852.25) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="162.33"
      y="265.5"
      width="216.75"
      height="52.25"
      transform="translate(541.4 583.25) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M393.52,317.75h187.85c7.98,0,14.45,6.47,14.45,14.45v202.3h-216.75v-202.3c0-7.98,6.47-14.45,14.45-14.45Z"
      transform="translate(974.9 852.25) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M605,265.5h23.49c5.07,0,9.18,4.11,9.18,9.18v259.82h-32.67c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
      transform="translate(1233.5 800) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="379.07"
      y="265.5"
      width="216.75"
      height="52.25"
      transform="translate(974.9 583.25) rotate(-180)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon119OrientationSingleArmSofaRight;
